import { PageHeading } from '@src/components/PageHeading/PageHeading';
import type { ReactNode } from 'react';
import { Container } from '@src/components/Container/Container';
import { Panel } from '@src/components/Panel/Panel';
import { Shell } from '@src/components/Shell/Shell';
import { Stack } from '@src/components/Stack/Stack';

export interface AuthFrameProps {
  title: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Stretch the card column to the auth width — the code step. */
  fill?: boolean;
  testId?: string;
}

/** Shared chrome for login, register, recover: title, card, optional footnote. */
export function AuthFrame({ title, subtitle, children, footer, fill = false, testId }: AuthFrameProps) {
  return (
    <Shell>
      <Container width="auth" gutter="narrow" pad="compact" grow as="main" testId={testId}>
        <Stack gap={8} wide={fill}>
          <Stack gap={2} align="center" className="landscape-sky-content">
            <PageHeading title={title} subtitle={subtitle} />
          </Stack>
          <Panel padding="large" elevated edges={{ pieces: 3 }}>
            {children}
          </Panel>
          {footer ? (
            <Stack align="center" wide className="landscape-sky-content">
              {footer}
            </Stack>
          ) : null}
        </Stack>
      </Container>
    </Shell>
  );
}
